<template>
  <div class="chat-widget__input-stats" v-if="inputValue">
    <span :class="{ 'chat-widget__limit--danger': isError }" v-tooltip.bottom.html="tooltipContent">
      Количество символов: {{ characterCount }}{{ limit ? ` / ${limit}` : '' }}
    </span>
    (~{{ pluralForm(tokenCount, ['токен', 'токена', 'токенов']) }})
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { pluralForm } from "@/services/helper";

const props = defineProps({
  inputValue: {
    type: String,
    required: true
  },
  limit: {
    type: Number,
    default: null
  },
  isError: {
    type: Boolean,
    default: false
  }
});
const tooltipContent = computed(() => props.isError ? `Зарегистрируйтесь, чтобы убрать лимиты`: '');

const characterCount = computed(() => props.inputValue.length);
const tokenCount = computed(() => Math.round(props.inputValue.length / 2.8));
</script>